/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateTenant = /* GraphQL */ `subscription OnCreateTenant(
  $filter: ModelSubscriptionTenantFilterInput
  $owner: String
) {
  onCreateTenant(filter: $filter, owner: $owner) {
    id
    tenantname
    subtenant
    address
    contact
    phone
    status
    servicepackage
    statuspayment
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTenantSubscriptionVariables,
  APITypes.OnCreateTenantSubscription
>;
export const onUpdateTenant = /* GraphQL */ `subscription OnUpdateTenant(
  $filter: ModelSubscriptionTenantFilterInput
  $owner: String
) {
  onUpdateTenant(filter: $filter, owner: $owner) {
    id
    tenantname
    subtenant
    address
    contact
    phone
    status
    servicepackage
    statuspayment
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTenantSubscriptionVariables,
  APITypes.OnUpdateTenantSubscription
>;
export const onDeleteTenant = /* GraphQL */ `subscription OnDeleteTenant(
  $filter: ModelSubscriptionTenantFilterInput
  $owner: String
) {
  onDeleteTenant(filter: $filter, owner: $owner) {
    id
    tenantname
    subtenant
    address
    contact
    phone
    status
    servicepackage
    statuspayment
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTenantSubscriptionVariables,
  APITypes.OnDeleteTenantSubscription
>;
export const onCreateVehicleAlarm = /* GraphQL */ `subscription OnCreateVehicleAlarm(
  $filter: ModelSubscriptionVehicleAlarmFilterInput
  $owner: String
) {
  onCreateVehicleAlarm(filter: $filter, owner: $owner) {
    id
    vehiclecode
    alarm
    timestamps
    vehicleID
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateVehicleAlarmSubscriptionVariables,
  APITypes.OnCreateVehicleAlarmSubscription
>;
export const onUpdateVehicleAlarm = /* GraphQL */ `subscription OnUpdateVehicleAlarm(
  $filter: ModelSubscriptionVehicleAlarmFilterInput
  $owner: String
) {
  onUpdateVehicleAlarm(filter: $filter, owner: $owner) {
    id
    vehiclecode
    alarm
    timestamps
    vehicleID
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleAlarmSubscriptionVariables,
  APITypes.OnUpdateVehicleAlarmSubscription
>;
export const onDeleteVehicleAlarm = /* GraphQL */ `subscription OnDeleteVehicleAlarm(
  $filter: ModelSubscriptionVehicleAlarmFilterInput
  $owner: String
) {
  onDeleteVehicleAlarm(filter: $filter, owner: $owner) {
    id
    vehiclecode
    alarm
    timestamps
    vehicleID
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteVehicleAlarmSubscriptionVariables,
  APITypes.OnDeleteVehicleAlarmSubscription
>;
export const onCreateVehicle = /* GraphQL */ `subscription OnCreateVehicle(
  $filter: ModelSubscriptionVehicleFilterInput
  $owner: String
) {
  onCreateVehicle(filter: $filter, owner: $owner) {
    id
    vehiclecode
    typevehicle
    location
    status
    VehicleAlarms {
      nextToken
      __typename
    }
    category
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateVehicleSubscriptionVariables,
  APITypes.OnCreateVehicleSubscription
>;
export const onUpdateVehicle = /* GraphQL */ `subscription OnUpdateVehicle(
  $filter: ModelSubscriptionVehicleFilterInput
  $owner: String
) {
  onUpdateVehicle(filter: $filter, owner: $owner) {
    id
    vehiclecode
    typevehicle
    location
    status
    VehicleAlarms {
      nextToken
      __typename
    }
    category
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleSubscriptionVariables,
  APITypes.OnUpdateVehicleSubscription
>;
export const onDeleteVehicle = /* GraphQL */ `subscription OnDeleteVehicle(
  $filter: ModelSubscriptionVehicleFilterInput
  $owner: String
) {
  onDeleteVehicle(filter: $filter, owner: $owner) {
    id
    vehiclecode
    typevehicle
    location
    status
    VehicleAlarms {
      nextToken
      __typename
    }
    category
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteVehicleSubscriptionVariables,
  APITypes.OnDeleteVehicleSubscription
>;
export const onCreateTyreAlarm = /* GraphQL */ `subscription OnCreateTyreAlarm(
  $filter: ModelSubscriptionTyreAlarmFilterInput
  $owner: String
) {
  onCreateTyreAlarm(filter: $filter, owner: $owner) {
    id
    serialnumber
    sensorid
    brand
    typetyre
    vehiclecode
    position
    alarms
    timestamps
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTyreAlarmSubscriptionVariables,
  APITypes.OnCreateTyreAlarmSubscription
>;
export const onUpdateTyreAlarm = /* GraphQL */ `subscription OnUpdateTyreAlarm(
  $filter: ModelSubscriptionTyreAlarmFilterInput
  $owner: String
) {
  onUpdateTyreAlarm(filter: $filter, owner: $owner) {
    id
    serialnumber
    sensorid
    brand
    typetyre
    vehiclecode
    position
    alarms
    timestamps
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTyreAlarmSubscriptionVariables,
  APITypes.OnUpdateTyreAlarmSubscription
>;
export const onDeleteTyreAlarm = /* GraphQL */ `subscription OnDeleteTyreAlarm(
  $filter: ModelSubscriptionTyreAlarmFilterInput
  $owner: String
) {
  onDeleteTyreAlarm(filter: $filter, owner: $owner) {
    id
    serialnumber
    sensorid
    brand
    typetyre
    vehiclecode
    position
    alarms
    timestamps
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTyreAlarmSubscriptionVariables,
  APITypes.OnDeleteTyreAlarmSubscription
>;
export const onCreateTyre = /* GraphQL */ `subscription OnCreateTyre(
  $filter: ModelSubscriptionTyreFilterInput
  $owner: String
) {
  onCreateTyre(filter: $filter, owner: $owner) {
    id
    serialnumber
    brand
    typetyre
    vehiclecode
    position
    sensorid
    pressure
    temperature
    battery
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTyreSubscriptionVariables,
  APITypes.OnCreateTyreSubscription
>;
export const onUpdateTyre = /* GraphQL */ `subscription OnUpdateTyre(
  $filter: ModelSubscriptionTyreFilterInput
  $owner: String
) {
  onUpdateTyre(filter: $filter, owner: $owner) {
    id
    serialnumber
    brand
    typetyre
    vehiclecode
    position
    sensorid
    pressure
    temperature
    battery
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTyreSubscriptionVariables,
  APITypes.OnUpdateTyreSubscription
>;
export const onDeleteTyre = /* GraphQL */ `subscription OnDeleteTyre(
  $filter: ModelSubscriptionTyreFilterInput
  $owner: String
) {
  onDeleteTyre(filter: $filter, owner: $owner) {
    id
    serialnumber
    brand
    typetyre
    vehiclecode
    position
    sensorid
    pressure
    temperature
    battery
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTyreSubscriptionVariables,
  APITypes.OnDeleteTyreSubscription
>;
export const onCreateAdmin = /* GraphQL */ `subscription OnCreateAdmin(
  $filter: ModelSubscriptionAdminFilterInput
  $owner: String
) {
  onCreateAdmin(filter: $filter, owner: $owner) {
    id
    nik
    name
    email
    position
    tenant
    username
    password
    accessrole
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAdminSubscriptionVariables,
  APITypes.OnCreateAdminSubscription
>;
export const onUpdateAdmin = /* GraphQL */ `subscription OnUpdateAdmin(
  $filter: ModelSubscriptionAdminFilterInput
  $owner: String
) {
  onUpdateAdmin(filter: $filter, owner: $owner) {
    id
    nik
    name
    email
    position
    tenant
    username
    password
    accessrole
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAdminSubscriptionVariables,
  APITypes.OnUpdateAdminSubscription
>;
export const onDeleteAdmin = /* GraphQL */ `subscription OnDeleteAdmin(
  $filter: ModelSubscriptionAdminFilterInput
  $owner: String
) {
  onDeleteAdmin(filter: $filter, owner: $owner) {
    id
    nik
    name
    email
    position
    tenant
    username
    password
    accessrole
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAdminSubscriptionVariables,
  APITypes.OnDeleteAdminSubscription
>;
export const onCreateSensorValue = /* GraphQL */ `subscription OnCreateSensorValue(
  $filter: ModelSubscriptionSensorValueFilterInput
) {
  onCreateSensorValue(filter: $filter) {
    id
    sensorId
    pH
    temperature
    salinity
    disolvedO2
    status
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSensorValueSubscriptionVariables,
  APITypes.OnCreateSensorValueSubscription
>;
export const onUpdateSensorValue = /* GraphQL */ `subscription OnUpdateSensorValue(
  $filter: ModelSubscriptionSensorValueFilterInput
) {
  onUpdateSensorValue(filter: $filter) {
    id
    sensorId
    pH
    temperature
    salinity
    disolvedO2
    status
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSensorValueSubscriptionVariables,
  APITypes.OnUpdateSensorValueSubscription
>;
export const onDeleteSensorValue = /* GraphQL */ `subscription OnDeleteSensorValue(
  $filter: ModelSubscriptionSensorValueFilterInput
) {
  onDeleteSensorValue(filter: $filter) {
    id
    sensorId
    pH
    temperature
    salinity
    disolvedO2
    status
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSensorValueSubscriptionVariables,
  APITypes.OnDeleteSensorValueSubscription
>;
